import React, { useEffect, useState, useContext } from "react";
import { CRMURL } from "../../../../api_links";
import { checkLoginCookie } from "../../../../auth/checkLoginCookie";

import { CRMContext } from "../../../contexts/settingsContexts/crm.context";

import {
  update_crm_convertkit_api_key,
  update_crm_convertkit_api_secret,
  update_crm_convertkit_form_id,
  update_crm_convertkit_tag_id,
} from "../updateFunctions";

import { uploadCRM } from "../uploadFunction";

import SelectInputField from "../../../common/selectInputField/selectInputField";
import InputField from "../../../common/inputField/inputField";
import Button from "../../../common/button/button";

const ConvertKit = () => {
  const [crm, setCrm] = useContext(CRMContext);
  const [formIDs, setFormIDs] = useState([]);
  const [tagIDs, setTagIDs] = useState([]);

  const { API_Key, API_Secret, form_id, tag_id } =
    crm.use_form.crm_details.crm_options.convertkit;

  const fetchConvertKitFormIDs = () => {
    const authToken = checkLoginCookie();
    if (!authToken) return;
    fetch(`${CRMURL}/convertkit/form_ids`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: authToken }),
    })
      .then((response) => response.json())
      .then((data) => {
        const forms = data?.forms?.forms;
        if (forms && forms?.length) {
          const tempForms = [];
          forms.forEach(({ id, name }) => {
            tempForms.push({ value: id, text: name });
          });
          setFormIDs(tempForms);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchConvertKitTagIDs = () => {
    const authToken = checkLoginCookie();
    if (!authToken) return;
    fetch(`${CRMURL}/convertkit/tag_ids`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: authToken }),
    })
      .then((response) => response.json())
      .then((data) => {
        const tags = data?.tags?.tags;
        if (tags && tags?.length) {
          const tempTags = [];
          tags.forEach(({ id, name }) => {
            tempTags.push({ value: id, text: name });
          });
          setTagIDs(tempTags);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchConvertKitFormIDs();
    fetchConvertKitTagIDs();
  }, []);

  return (
    <React.Fragment>
      <InputField
        label={"API_Key"}
        defaultInputValue={API_Key}
        type={"password"}
        callback={update_crm_convertkit_api_key}
        context={crm}
        updateContext={setCrm}
      />
      <InputField
        label={"API_Secret"}
        defaultInputValue={API_Secret}
        type={"password"}
        callback={update_crm_convertkit_api_secret}
        context={crm}
        updateContext={setCrm}
      />
      <Button
        title={"Fetch forms & Tags"}
        callback={() => {
          fetchConvertKitFormIDs();
          fetchConvertKitTagIDs();
        }}
        callbackData={"none"}
      />
      <SelectInputField
        inputFieldId={
          "settings_privacy_contact_detail_form_submission_endpoint_list"
        }
        options={formIDs}
        label={"Select Form"}
        defaultInputValue={form_id}
        valuesObjectType={true}
        callback={update_crm_convertkit_form_id}
        context={crm}
        updateContext={setCrm}
      />
      <SelectInputField
        inputFieldId={
          "settings_privacy_contact_detail_form_submission_endpoint_tag"
        }
        options={tagIDs}
        label={"Select Tag"}
        defaultInputValue={tag_id}
        valuesObjectType={true}
        callback={update_crm_convertkit_tag_id}
        context={crm}
        updateContext={setCrm}
      />
      <Button
        title={"Save ConvertKit Settings"}
        callback={uploadCRM}
        callbackData={crm}
      />
    </React.Fragment>
  );
};

export default ConvertKit;
